import type {RouteLocationNormalized} from 'vue-router';
import {defineNuxtRouteMiddleware, navigateTo, useLocalePrefix} from '#imports';
import {sanitizeSingleStringParam} from '~/utils/query-param-sanitizer';

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
    const query = to.query.q;

    if (!query || sanitizeSingleStringParam(query)?.trim() === '') {
        const {withLocalePrefix} = useLocalePrefix();
        return navigateTo(withLocalePrefix('/'), {external: true});
    }
});
